import { createAction, props } from '@ngrx/store';

import { LoginRequest, LoginResponse } from '@offconon/core-api';

export const domainUserLogin = createAction(
  '[Domain User] Login',
  props<{ loginRequest: LoginRequest }>(),
);

export const domainUserLoginSuccess = createAction(
  '[Domain User] Login Success',
  props<{ loginResponse: LoginResponse }>(),
);

export const domainUserLoginFailure = createAction(
  '[Domain User] Login Failure',
  props<{ error: any }>(),
);

export const domainUserLogout = createAction('[Domain User] Logout');

export const domainUserSetToken = createAction(
  '[Domain User] Set Token',
  props<{ user_token: string }>(),
);

export const loadGuestToken = createAction('[Domain User] Load Guest Token');

export const loadGuestTokenSuccess = createAction(
  '[Domain User] Load Guest Token Success',
  props<{ user_token: string }>(),
);
